import {Vue} from 'ui.vue';

Vue.component('app-vue-components-formbron', {
	data()
	{
		return {
			state: {
				open: false,
				sended: false,
			},
			data: {
				phone: '',
				name: ''
			},
			lastresult: {
				title: '',
				text: ''
			}
		}
	},
	created () {
		//this.assets.images = APP.config.assets.images;
		BX.addCustomEvent('app-vue-components-formbron:toggle' , this.toggleOpen);
	},
	methods: {

		
		
	},
	computed: {
		valid() {
			return !!(this.data.phone.replace(/[^\d]/g, '').length==11 && this.data.name);
		}
	},
	watch: {
		'data.phone' (val,oval) {
			
			if (val.length > oval.length) {
			
				let phone = val.replace(/[^\d]/g, '').substring(0,11);
				let lenPhone = phone.length;
				let tt = phone.split('');
				
				if (lenPhone > 1) tt.splice(1,"", "(");
				if (lenPhone > 3) tt.splice(5,"", ")");
				if (lenPhone > 5) tt.splice(9,"", "-");
				if (lenPhone > 7) tt.splice(12,"", "-");
				
				let phone_formated = '+'+tt.join('');
				
				if (val != phone_formated) {
					this.data.phone = phone_formated;
				}
			}
		}
	},
	methods: {
		showMessage(title,text) {
			this.lastresult.title = title;
			this.lastresult.text = text;
			this.state.sended = true;
		},
		send() {
			let self = this
			
			BX.ajax({   
					url: '/local/ajax.php',
					data: this.data,
					method: 'POST',
					dataType: 'json',
					timeout: 30,
					async: true,
					processData: true,
					scriptsRunFirst: true,
					emulateOnload: true,
					start: true,
					cache: false,
					onsuccess: function(data){
						console.log(data)
						
						if (data.status) {
							self.showMessage('Ошибка!','Попробуйте позже');
                        } else {
							self.showMessage('Спасибо!','мы свяжемся с вами в течение рабочего дня');
						}
					},
					onfailure: function(){
						self.showMessage('Ошибка!','Попробуйте позже');
					}
				})
		},
		
		toggleOpen () {
			this.state.open = !this.state.open;
		},
		
		close () {
			this.state.open = false;
		},
	},
	template: `
    <div>
		<div v-on:click="toggleOpen" class="bron">
			<a href="#" class="show_popup"><span class="icon"></span><img src="/local/assets/img/icons-top/Text.svg"></a>
		</div>
		
		<div v-if="state.open"
				class="overlay_popup"
				style="display:block"
			></div>
		
		<div v-if="state.open"
				class="popup"
				style="display:block"
			>
			<div class="object">
				<button v-on:click="close" class="clouse">
					<span></span>
					<span></span>
				</button>
				<div class="forms" v-if="!state.sended">
					<div class="zag">Понравилась локация и атмосфера лофта?</div>
					<div class="title">оставьте заявку</div>
					<div class="sub-title">и мы свяжемся с вами, чтобы обсудить детали</div>
					<form action="#">
						<div class="input-container">
							<input type="text" v-model="data.name" placeholder="Имя">
							<div class="label">Имя</div>
						</div>
						<div class="input-container">
							<input type="text" v-model="data.phone" placeholder="Телефон">
							<div class="label">Телефон</div>
						</div>
						<button v-on:click.prevent="send" class="btn btn--border">Перезвоните мне</button>
						<p>Нажимая кнопку «Перезвоните мне», я даю <a href="/legal.pdf" target="_blank">согласие на обработку персональных данных</a></p>
					</form>
				</div>
				<div class="fanks" v-if="state.sended" style="display:block" >
					<div class="title">{{lastresult.title}}</div>
					<div class="text">{{lastresult.text}}</div>
				</div>
			</div>
		</div>
		
	</div>
	`
});
